var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#14AC9C",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.225 27.637c0-2.955 2.396-5.35 5.35-5.35h8.486c2.955 0 5.35 2.395 5.35 5.35v2.121c0 .612-.496 1.108-1.108 1.108-.612 0-1.108-.496-1.108-1.108v-2.121c0-1.731-1.404-3.134-3.134-3.134h-8.485c-1.731 0-3.134 1.403-3.134 3.134v2.121c0 .612-.497 1.108-1.109 1.108s-1.108-.496-1.108-1.108v-2.121zM16.818 11.775c-1.73 0-3.134 1.403-3.134 3.134 0 1.731 1.403 3.134 3.134 3.134 1.731 0 3.134-1.403 3.134-3.134 0-1.73-1.403-3.134-3.134-3.134zm-5.35 3.134c0-2.955 2.395-5.35 5.35-5.35 2.955 0 5.351 2.395 5.351 5.35 0 2.955-2.396 5.351-5.35 5.351-2.956 0-5.352-2.396-5.352-5.35zM27.412 23.255c.153-.592.757-.949 1.35-.796 2.361.61 4.011 2.739 4.013 5.177v2.122c0 .612-.496 1.108-1.108 1.108-.612 0-1.109-.496-1.109-1.108v-2.12c-.001-1.429-.968-2.675-2.35-3.032-.593-.154-.95-.758-.796-1.35zM23.169 10.53c.152-.593.755-.95 1.348-.799 2.368.606 4.024 2.74 4.024 5.184s-1.656 4.577-4.024 5.183c-.593.152-1.196-.206-1.348-.799-.152-.593.206-1.196.799-1.348 1.386-.355 2.356-1.605 2.356-3.036 0-1.432-.97-2.681-2.357-3.036-.592-.152-.95-.756-.798-1.349z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.6c3eef270cefa45b7471749b62f1bb9f.svg";
export { ForwardRef as ReactComponent };